<!--
 * @Author: guoyu
 * @Date: 2020-05-08 14:54:43
 * @LastEditors: zheng zheng@sence.sg
 * @LastEditTime: 2022-12-19 16:58:13
 * @Description: 優惠券相关
 -->
<template>
  <div class="coupons-info" :class="popupShow && 'coupons-info-wrap'">
    <div class="coupons-title">優惠券</div>
    <div class="coupon-entry" @click="openCouponsList">
      <span class="coupon-text" :class="{ 'coupon-has': couponsList.length }">{{
        couponsText
      }}</span>
      <i
        class="right-arrow"
        :class="{ 'coupons-show-arrow': couponsList.length && popupShow }"
        v-if="!$route.query.orderNo"
      ></i>
    </div>
    <general-checkbox
      class="list-container"
      v-if="couponsList.length && isPc && popupShow"
      v-model="currentUuid"
      :slotEmit="true"
      :options="couponsList"
      :col="2"
      :rowStyle="{ 'justify-content': 'space-between' }"
      :colStyle="{ 'margin-right': '11px' }"
    >
      <template v-slot="{ item, checked }">
        <CouponsBar
          :couponsInfo="item"
          :noUseButton="true"
          :checked="checked"
          :count="item.count"
          :disabled="getDisabledStatus(item)"
          @click.native="checkedCoupons(item)"
        ></CouponsBar>
      </template>
    </general-checkbox>
  </div>
</template>
<script>
import GeneralCheckbox from '@/components/common/checkbox/general-checkbox';
import CouponsBar from './coupons/bar';
export default {
  name: 'CouponsInfo',
  components: {
    CouponsBar,
    GeneralCheckbox
  },
  props: {
    isFromNew: { type: Boolean, default: false },
    allPrice: { type: Number, default: 0 }, // 商品总金额，用于判断優惠券可用性
    couponsList: { type: Array, default: () => [] },
    couponUuid: { type: String, default: '' },
    isPc: { type: Boolean, default: true },
    firstCoupon: { type: Number, default: 0 }, // 首單優惠，會影響滿減
    paymentMethod: { type: String, default: 'Balance' } // 支付方式
  },
  computed: {
    couponsText() {
      if (this.coupons && !this.isPc) return '-' + this.coupons;
      if (!this.couponsList.length) return '暫無可用';
      if (this.availableNum) return '當前' + this.availableNum + '張可用';
      if (this.couponsList.length && !this.availableNum) return '訂單金額未滿';
      return '暫無可用';
    },
    currentUuid: {
      get() {
        // 如果沒有選中的
        if (this.checkedUuid === 'cancel') return '';
        // 优先选中用户选中的，用户没选中优先选中用户要使用的，用户未做操作默认选中可用的
        return this.checkedUuid || this.couponUuid || this.defaultUuid;
      },
      set(newVal) {
        this.checkedUuid = newVal;
      }
    },
    // 滿減對比價格
    limitPrice() {
      return this.allPrice - this.firstCoupon;
    }
  },
  watch: {
    allPrice() {
      this.initCheck();
    },
    couponsList() {
      this.initCheck();
    },
    limitPrice() {
      this.useCoupons(this.couponUuid);
    },
    // 新人优惠券只能使用nicee币支付
    paymentMethod(nVal, oVal) {
      if (nVal != oVal) {
        this.initCheck();
        this.useCoupons('');
      }
    }
  },
  data() {
    return {
      coupons: 0, // 优惠金额
      popupShow: false,
      availableNum: 0, // 可用優惠券数量
      defaultUuid: '',
      checkedUuid: '',
      couponOffTemplates: [
        1,
        2,
        3,
        // 折扣類型的優惠券
        'SIXTY_PERCENT_OFF', // 四折s
        5,
        // 'HALF_OFF',
        'FORTY_PERCENT_OFF',
        'THIRTY_PERCENT_OFF',
        'TWENTY_PERCENT_OFF',
        'TEN_PERCENT_OFF'
      ]
    };
  },
  methods: {
    openCouponsList() {
      if (
        this.$route.query.orderNo ||
        !this.couponsList ||
        !this.couponsList.length
      )
        return;
      this.initCheck();
      if (this.isPc) {
        this.popupShow = !this.popupShow;
        return;
      }
      this.popupShow = true;
    },
    close() {
      this.popupShow = false;
    },
    /**
     * @description: 打开弹窗时初始化数据
     */
    initCheck() {
      this.getDefaultChecked();
      this.couponsList.some(item => {
        // 如果当前选中的優惠券不可用还原选择
        if (
          this.couponUuid === item.uuid &&
          this.limitPrice < item.startAmount
        ) {
          this.coupons = 0;
          this.$emit('change', { coupons: 0, uuid: undefined });
        }
      });
    },
    /**
     * @description: 选中優惠券
     */
    checkedCoupons(item) {
      if (this.getDisabledStatus(item)) return;
      // pc中交互有差異
      if (this.currentUuid === item.uuid) {
        this.checkedUuid = this.isPc ? '' : 'cancel';
      } else {
        this.checkedUuid = item.uuid;
      }
      if (this.isPc) {
        this.useCoupons(this.checkedUuid);
      }
    },
    /**
     * @description: 确定要使用的優惠券，由于该方法会被父组件调用，采用传参
     */
    useCoupons(useUuid) {
      if (!useUuid) {
        this.coupons = 0;
        this.checkedUuid = this.isPc ? '' : 'cancel';
        this.$emit('change', { coupons: 0, uuid: '' });
      } else {
        this.couponsList.some(item => {
          if (useUuid === item.uuid && item.startAmount <= this.limitPrice) {
            const maxAmount = item.couponAmount;
            // 半價優惠券
            if (item.couponTemplate === 'HALF_OFF') {
              let price = this.limitPrice / 2;
              price = price > maxAmount ? maxAmount : price;
              this.coupons = price;
            } else if (this.couponOffTemplates.includes(item.couponTemplate)) {
              const index = this.couponOffTemplates.findIndex(
                template => template === item.couponTemplate
              );
              const offNumber = index + 1; //折扣
              let price = (this.limitPrice * (10 - offNumber)) / 10;
              price = price > maxAmount ? maxAmount : price;
              this.coupons = price;
              console.log('price', price);
            } else {
              // console.log('this.coupons', this.coupons);
              this.coupons = item.couponAmount;
            }
            this.couponName = item.couponName;
            this.$emit('change', {
              coupons: this.coupons,
              uuid: item.uuid,
              type: item.couponTemplate,
              couponName: item.couponName
            });
            return true;
          }
        });
      }
      if (!this.isPc) {
        this.close();
      }
    },
    getDisabledStatus(item = {}) {
      // if(item.couponTemplate == 'FREE_ORDER') {
      //   return 150 > this.limitPrice
      // }
      if (
        this.paymentMethod != 'Balance' &&
        item.couponTemplate == 'NEWCOMER_EXPERIENCE'
      ) {
        return true;
      }
      return item.startAmount > this.limitPrice;
    },
    /**
     * @description: 在用户未选用優惠券时默认选中一个最大可用優惠券
     */
    getDefaultChecked() {
      this.checkedUuid = '';
      let max = 0;
      let maxUuid = '';
      this.availableNum = 0;
      this.couponsList.forEach(item => {
        // 限制金额小于当前金额
        if (item.startAmount > this.limitPrice) return;
        if (
          this.paymentMethod != 'Balance' &&
          item.couponTemplate == 'NEWCOMER_EXPERIENCE'
        ) {
          return;
        }
        this.availableNum += item.count;
        if (item.couponAmount > max) {
          max = item.couponAmount;
          maxUuid = item.uuid;
        }
      });
      if (this.isPc) return;
      this.defaultUuid = maxUuid;
    }
  }
};
</script>
<style lang="scss" scoped>
.coupons-info {
  display: flex;
  height: 70px;
  padding: 30px 18px;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  color: #333333;
}
.coupons-title {
  font-weight: 600;
}
.coupon-entry {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
  line-height: 1;
  font-size: 16px;
}
.coupon-text {
  font-weight: 500;
  color: #999999;
}
.right-arrow {
  display: block;
  height: 14px;
  width: 14px;
  margin-left: 12px;
  background: url('~@/assets/imgs/seeAll.png') no-repeat center;
  background-size: 100% 100%;
  opacity: 0.5;
}
.line-bottom {
  margin-bottom: 15px;
}
.use-counpons {
  position: absolute;
  right: 18px;
  font-size: 16px;
  font-weight: 400;
  color: $color-orange;
}
.list-container {
  padding-bottom: 65px;
}
.coupon-has {
  color: $color-orange;
}
.no-coupons {
  margin-top: 91px;
  text-align: center;
  font-size: 14px;
  color: #666666;
}
.coupons-none-icon {
  display: inline-block;
  height: 83px;
  width: 100px;
  margin-bottom: 40px;
  background: url('~@/assets/images/coupons-none.png') no-repeat center;
  background-size: 100% 100%;
}
@media screen and (min-width: 600px) {
  .coupons-info {
    position: relative;
    display: block;
    height: auto;
    overflow: hidden;
    height: auto;
    box-sizing: content-box;
    padding: 30px 0px 40px;
  }
  .coupons-title,
  .coupon-entry {
    float: left;
    margin-right: 40px;
  }
  .coupons-info-wrap {
    .coupons-title,
    .coupon-entry {
      margin-bottom: 30px;
    }
  }
  .list-container {
    clear: left;
    width: 100%;
    padding-bottom: 0;
  }
  .right-arrow {
    transform: rotate(90deg);
    transition: transform ease 0.3s;
    opacity: 0.9;
  }
  .coupons-show-arrow {
    transform: rotate(-90deg);
  }
}
</style>
